const successConstant = {
  INVOICE_CHECKED: 'has been checked!!',
  OPTIMA_INDENT_SAVE: 'Changes Saved!',
  OPTIMA_MATERIAL_DELETE: 'Materials Deleted!',
  OPTIMA_INDENT_DELETE: 'Selected numbers deleted!',
  OPTIMA_MOVE_CONSIGNEE: 'Consignee moved to new number',
  INVOICE_REAPPROVE: 'Selected Invoices Approved!',
  VOUCHER_VERIFY_REJECT: 'Selected Vouchers put on Hold',
  VOUCHER_APPROVE_REJECT: 'Selected Vouchers Approved!',
  VOUCHER_VERIFY: 'Selected Vouchers Verified!',
  VOUCHER_APPROVE: 'Selected Vouchers Approved!',
  INVOICE_VERIFY: 'Selected Invoices Verified!',
  INVOICE_APPROVE: 'Selected Invoices Approved!',
  INVOICE_HOLD: 'Selected Invoices Hold!',
  INVOICE_REJECTED_SSC: 'Selected Invoices Rejected!',
  INVOICE_SAVED: 'Data successfully saved!',
  INVOICE_APPROVED: 'Invoice Approved!',
  INVOICE_RETURNED: 'Invoice Returned!',
  INVOICE_VERIFIED: 'Invoice Verification Completed!',
  GENERATE_VOUCHER: 'Voucher generated for Selected invoices!',
  OPTIMA_CONSIGNEE_DELETE: 'Selected Consignee(s) deleted!',
  OPTIMA_INDENT_CREATION: 'Indents getting created....',
  ADD_RECORD: 'Record Added!',
  UPDATE_RECORD: 'Record Updated!',
  BULKUPLOAD: 'Validating and Uploading data from the excel..',
  BULKUPLOAD_COUNT: '#firstArgument# Uploaded and #secondArgument# Invalid records out of #thirdArgument#',
  BULKUPLOAD_STATUS: '#firstArgument# % Completed',
  BULKUPLOAD_SKIPPED_COUNT: '#firstArgument# Uploaded #secondArgument# Skipped #thirdArgument# Invalid out of #fourthArgument# records',
  BULK_MIRO_COUNT: '#firstArgument# Updated and #secondArgument# Not updated out of #thirdArgument#',
  BULK_INDENTS_CREATE_COUNT: '#firstArgument# Indents created and #secondArgument# Rejected Indent',
  CONSIGNEE_REMOVED: '#firstArgument#  consignee removed from your list',
  SOLD_CUSTOMER_UPDATE: 'Sold To changed from #firstArgument#  to  #secondArgument#',
  DELETE_GATE: 'Pickups removed from list',
  DELETE_CONSIGNEES: 'Selected consignees deleted!',
  INDENT_CREATION: 'Indent created with number #firstArgument#',
  REQUEST_CREATION: 'Request created with number #firstArgument#',
  REQUEST_REJECTED: 'Rejection of #firstArgument# is successful',
  INDENT_UPDATION: 'You have updated the indent #firstArgument#',
  INDENT_CUSTOMFILEDS_SAVE: 'Additional information Saved',
  EXPORT_VIA_EMAIL: 'You will receive the requested data via email in a few minutes!',
  PAYMENT_DOWNLOAD_VIA_EMAIL: 'You will receive the requested data via email in a few minutes!',
  UPDATED_FREIGHT: 'Updated the freight rate for #firstArgument#',
  COMMENTS_ADDED: 'Comments added..',
  INVOICE_CUSTOMFIELDS_UPDTAE: 'Details updated',
  DELETE_HOLIDAY: 'Holiday deleted successfully.',
  INVOICE_CREATION_SUCCESS: 'Invoice created successfully.',
  INVOICE_UPDATE_SUCCESS: 'Invoice updated successfully.',
  UPDATE_SUCCESS: 'Changes has been successfully updated!',
  INVOICE_STATUS_CHANGE: 'Invoice #firstArgument#!',
  GRN_SAVE_SUCCESS: 'GRN Saved Success!',
  GRN_SUBMIT_SUCCESS: 'GRN Approved',
  INDENT_ACCEPTED: 'Indent Accepted',
  INDENT_REJECTED: 'Indent Rejected',
  CONTAINER_SUBMITTED: 'Container Submitted',
  TRUCK_TYPE_REQUESTED: 'Truck Type change Requested',
  RFQ_UPDATED: 'RFQ updated successfully',
  DEBIT_ADJUSTMENT_SUCCESS: 'Debit Adjustment updated succesfully',
  LOGO_UPDATED_SUCCESS: 'Logo updated successfully',
  LOGO_DELETED_SUCCESS: 'Logo deleted successfully',
  HSN_SAC_UPDATED: 'SAC UPDATED',
  CERTIFICATE_UPDATED: 'Certification details updated',
  NEWS_USER_ADDED: 'Added successfully.',
  DELETE_USER: 'Deleted successfully.',
  UPDATED_EXTRA_KM: 'Updated Extra KM successfully',
  CONSIGNMENT_UPDATE_SUCCESS: 'Consignment number has been saved.Track the consignment from the CONSIGNMENT STATUS TIMELINE tab.',
  CHANGE_REQUESTED: 'Change Requested',
  SO_UPDATE_SUCCESS: 'SO number has been saved.',
  EXIM_MASTER_CANCEL_FAILS: '#firstArgument# has been cancelled',
  CONTAINER_PICKUP_SUCCESS: 'Container pickup successful',
  CREATE_RETURN_SUCCESS: 'Return indent created with number #firstArgument#!',
  DRAFT_CREATION: 'Draft creation successful!',
  FREIGHT_PROVISION_SUCCESS: 'Freight Provision was sent to ERP',
  FREIGHT_INVOICE_SUCCESS: 'Freight Invoice was sent to ERP',
  STOP_SUCCESS: 'Stop success',
  DELIVERY_NUMBER_UPDATE_SUCCESS: 'Delivery number saved successfully!',
  CONSIGNEE_UPDATE: 'Consignee SuccessFully Updated',
  WALLET_CONFIGURATIONS_UPDATED: 'Wallet Configurations Updated Successfully',
  FREIGHT_BILL_CONFIGURATIONS_UPDATED: 'Freight Bill Configurations Updated Successfully',
  SHIPMENT_BOOKED: 'Shipment Booked',
  VERIFY_INVOICE_SUCCESS: 'Successful',
  PENALTY_RULE_DELETE_SUCCESS: 'Penalty Rule deleted successfully',
  TRANSIT_PENALTY_CONFIG_SAVE_SUCCESS: 'Transit Penalty Config updated successfully',
  SLAB_CREATED_SUCCESS: 'Slab created successfully',
  SLAB_DELETED_SUCCESS: 'Slab deleted successfully',
  SLAB_UPDATED_SUCCESS: 'Slab updated successfully',
  INDENT_BOOKING_CONFIRMED: 'Successfully Confirmed Booking',

  VENDOR_DEPOT_SUCCESS: 'Vendor Depot added successfully',
  VENDOR_DEPOT_UPDATE_SUCCESS: 'Vendor Depot updated successfully',

  PROFILE_LR_DEACTIVATED: 'Current LR Deactivated',
  PROFILE_LR_UPDATED: 'LR Updated',
  CONTRACT_UPDATE_SUCCESS: 'Contract Updated Successfully',
  RECONCILIATION_SUCCESS: 'Package Update Successfully',
  CUSTOM_FIELDS_UPDATED_SUCCESS: 'Custom fields updated successfully',
  GRN_SENT_FOR_APPROVAL: 'GRN submission sent for approval',
  GRN_AUTO_APPROVED: 'GRN submission has been auto approved by system',
  PAYMENT_GENERATION_SUCCESSFULLY_QUEUED: 'Payment generation successfully queued',
  REPORT_GENERATE: 'Report generation queued successfully',
  WORKFLOW_CREATED: 'Workflow created successfully',
  WORKFLOW_UPDATED: 'Workflow updated successfully',

  EXCESS_MATERIAL_SUCCESS: 'Excess Material successfully created',
  EXCESS_MATERIAL_UPDATED: 'Excess Material successfully updated',
  EXCESS_MATERIAL_DELETED: 'Excess Material successfully deleted',
  EXCESS_MATERIAL_FAILED: 'Excess Material creation failed : #firstArgument#',
  RFQ_REDIRECT_TO_INDENT_PAGE: 'Action Completed, Redirecting to Indent Page',
  RFQ_APPROVAL_SUCCESS: 'RFQ approval done successfully',
  BULK_APPROVAL_SUCCESS: '#firstArgument# invoice(s) moved to #secondArgument#',
  BULK_APPROVAL_PARTIAL_FAIL: '#firstArgument# invoice(s) failed to update',
};

export default successConstant;
